import React, { useState } from "react";
import { TimePicker } from "antd";
import ScheduleFieldWrapper from "./ScheduleFieldWrapper";
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'

const ScheduleTimePicker = ({
  label = "Time",
  required = false,
  value,
  onChange,
  disabled = false,
  placeholder = "Select time",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <ScheduleFieldWrapper label={label} required={required}>
      <TimePicker
        disabled={disabled}
        value={value}
        onChange={onChange}
        style={{ width: "100%", border: "none", padding: 0, margin: 0, hover: "none", boxShadow: "none", display: "flex", justifyContent: "space-between", background: "none" }}
        placeholder={placeholder}
        onOpenChange={(open) => setIsOpen(open)}
        superPrevIcon={<></>}
        superNextIcon={<></>}
        suffixIcon={<></>}
      />
      {isOpen ? (
        <CaretUpOutlined className="h-6 w-6 cursor-pointer text-btnDisableGray -mt-[13px] justify-end" />
      ) : (
        <CaretDownOutlined className="h-6 w-6 cursor-pointer text-btnDisableGray -mt-[13px] justify-end" />
      )}
    </ScheduleFieldWrapper>
  );
};

export default ScheduleTimePicker;
